import { useDispatch } from 'react-redux';

import type { AppDispatch } from '@/store';

function useAppDispatch() {
  return useDispatch<AppDispatch>();
}

export default useAppDispatch;
